import { styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Icons as GridIcons } from "Components/AppGrid/shipeezi-new-grid";
import { colors } from "@zapalacorp/tokens";
import { FiCalendar, FiSend } from "react-icons/fi";
import { MdOutlineCancel } from "react-icons/md";

import Button from "../../../../../components/Form/Button";

const styles = makeStyles(() => ({
  pastDueDate: {
    color: "#D92D20",
  },

  loadingIcon: {
    color: "#475467",
  },
  maxWidthColumn: {
    maxWidth: 150,
  },
}));

export const LocationWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  flexWrap: "nowrap",
  gap: 4,
  "& span": {
    overflow: "hidden",
    color: colors.gray600,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    cursor: "default",
    maxWidth: "100%",

    fontFamily: "Manrope",
    fontSize: 12,
    fontWeight: 400,
    lineHeight: "16px",
    letterSpacing: 0.4,
  },
}));

export const TransshipmentsGrid = styled("div")(() => ({
  padding: "24px 32px",
  display: "flex",
  flexDirection: "row",
  "& > div": {
    width: "100%",
  },

  "& .MuiTableContainer-root > table.MuiTable-root > tbody > tr:nth-child(odd)": {
    backgroundColor: `${colors.gray50} !important`,
  },
}));

export const ViewTodayIcon = styled(FiCalendar)(() => ({
  marginRight: "8px",
  fontSize: "14px",
}));

export const ViewIcon = styled(GridIcons.view)(() => ({
  cursor: "pointer",
}));

export const EditIcon = styled(GridIcons.edit)(() => ({
  cursor: "pointer",
}));

export const DeleteIcon = styled(GridIcons.delete)(() => ({
  cursor: "pointer",
}));

export const CancelIcon = styled(MdOutlineCancel)(() => ({
  cursor: "pointer",
}));

export const PublishIcon = styled(FiSend)(() => ({
  cursor: "pointer",
}));

export const ShowTodayButton = styled(Button)(() => ({
  borderRadius: "8px",
  border: "1px solid  #E4E7EC",
  "&:focus": {
    border: "1px solid  #0055A4",
    color: "#0055A4",
  },
}));

export const OrderOption = styled("span")(() => ({
  cursor: "pointer",
  display: "flex",
}));

export const DescriptionModalConfirm = styled("div")(() => ({
  display: "flex",
  gap: "0.7rem",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  flexDirection: "column",
  "& span": {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
  },
}));

export const IconWrapper = styled("div")(() => ({
  marginTop: "-4px",
}));

export default styles;
